import React, { useState } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const reviews = [
    { name: "Ahmet Y****", comment: "Taşınma sürecim çok hızlı ve sorunsuz geçti, teşekkürler!" },
    { name: "Ayşe K****", comment: "Eşyalarıma çok dikkat ettiler, kesinlikle tavsiye ederim." },
    { name: "Mehmet A****", comment: "Asansörlü taşıma harikaydı, ekibe teşekkürler." },
    { name: "Fatma S****", comment: "Şehirler arası taşındım, her şey mükemmel organize edildi." },
    { name: "Ali D****", comment: "Fiyat performans çok iyi, tekrar çalışırım." },
    { name: "Zeynep T****", comment: "Ekip çok kibar ve profesyonel, memnun kaldım." },
    { name: "Hakan B****", comment: "Ofis taşımada bir numara, hızlı ve güvenilir." },
    { name: "Elif G****", comment: "Depolama hizmeti süper, eşyalarım güvende." },
    { name: "Murat Ç****", comment: "Taşınma stresimi tamamen aldılar, harika bir ekip." },
    { name: "Selin E****", comment: "Her şey zamanında yapıldı, çok teşekkür ederim." },
    { name: "Burak Ö****", comment: "Asansörlü sistemle taşınmak çok rahattı." },
    { name: "Derya M****", comment: "Şehirler arası hizmetleri çok başarılı, öneririm." },
    { name: "Emre Ş****", comment: "Eşyalarım çiziksiz teslim edildi, süper!" },
    { name: "Gizem P****", comment: "Ekip çok ilgili, her aşamada bilgilendirdiler." },
    { name: "Okan T****", comment: "Fiyatlar uygun, hizmet kaliteli." },
    { name: "Seda H****", comment: "Taşınma artık korkulu rüyam değil, teşekkürler!" },
    { name: "Can K****", comment: "Ofis taşımada çok profesyoneller." },
    { name: "Ece R****", comment: "Depolama için en iyi tercih, çok memnunum." },
    { name: "Tolga B****", comment: "Hızlı ve güvenilir bir firma, tebrikler." },
    { name: "Buse N****", comment: "Eşyalarım tertemiz teslim edildi." },
    { name: "Kaan Y****", comment: "Asansörlü taşıma ile zamandan tasarruf ettim." },
    { name: "Pınar Z****", comment: "Şehirler arası taşımada bir numara!" },
    { name: "Deniz U****", comment: "Ekip çok nazik ve işlerini iyi yapıyor." },
    { name: "Cem L****", comment: "Her şey planlandığı gibi ilerledi." },
    { name: "İpek V****", comment: "Fiyatlar makul, hizmet harika." },
    { name: "Barış S****", comment: "Taşınma sürecim çok kolay geçti." },
    { name: "Naber Ö****", comment: "Depolama hizmeti çok pratik." },
    { name: "Lale T****", comment: "Ekip çok profesyonel, teşekkürler!" },
    { name: "Serkan G****", comment: "Hızlı ve güvenilir bir taşıma oldu." },
    { name: "Tuba Ç****", comment: "Asansörlü sistemle taşınmak harika." },
    { name: "Yiğit D****", comment: "Şehirler arası hizmet süperdi." },
    { name: "Aslı E****", comment: "Eşyalarım zarar görmeden taşındı." },
    { name: "Onur F****", comment: "Ekip çok yardımcı oldu, teşekkürler." },
    { name: "Ebru H****", comment: "Ofis taşımada çok iyiler." },
    { name: "Veli K****", comment: "Hizmetten çok memnun kaldım." }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex + 4 >= reviews.length ? 0 : prevIndex + 4
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex - 4 < 0 ? Math.floor(reviews.length/4) * 4 : prevIndex - 4
    );
  };

  return (
    <section className="py-16 bg-gray-100">
      <div className="container-custom">
        <h2 className="section-title text-center mb-12">Müşteri Yorumları</h2>
        
        <div className="relative">
          {/* Slider Kontrolleri */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 bg-white p-2 rounded-full shadow-md z-10 text-primary hover:text-white hover:bg-primary transition-colors"
            aria-label="Önceki yorumlar"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 overflow-hidden">
            {reviews.slice(currentIndex, currentIndex + 4).map((review, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-lg shadow-md"
              >
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold">
                    {review.name.charAt(0)}
                  </div>
                  <div className="ml-3">
                    <h4 className="font-semibold">{review.name}</h4>
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-gray-600">{review.comment}</p>
              </div>
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 bg-white p-2 rounded-full shadow-md z-10 text-primary hover:text-white hover:bg-primary transition-colors"
            aria-label="Sonraki yorumlar"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 